import { Input } from 'commons/components';
import { IdentityProviderMapping } from 'modules/settings/pods/settings-integrations/settings-integrations-active-directory/types/active-directory.type';

type InputDataPointType = {
    pocFieldInputName: string;
    pocFieldInputValue: string;
    pocFieldInputDisabled: boolean;
    identityProviderIndex: number;
    onChangeIdentityProviderMapping: <K extends keyof IdentityProviderMapping>(
        index: number,
        field: K,
        value: IdentityProviderMapping[K]
    ) => void;
};

export const InputDataPoint: React.FC<InputDataPointType> = (props) => {
    const {
        pocFieldInputDisabled,
        pocFieldInputName,
        pocFieldInputValue,
        identityProviderIndex,
        onChangeIdentityProviderMapping,
    } = props;

    return (
        <Input
            className="without-label"
            name={pocFieldInputName}
            placeholder="settings.integrations.active-directory.data-points.mapping.poc.placeholder"
            value={pocFieldInputValue}
            onChange={(_field, value) =>
                onChangeIdentityProviderMapping(identityProviderIndex, 'operatorField', value as string)
            }
            disabled={pocFieldInputDisabled}
        />
    );
};
